<template>
  <div class="content">
    <!-- 状态栏 -->
    <div class="status-bar">
<!--      <div class="time">09:36</div>
      <div class="status-icons">
        <div class="signal"></div>
        <div class="wifi"></div>
        <div class="battery"></div>
      </div>-->
    </div>

    <!-- 联系按钮 -->
    <div class="contact-buttons">
      <div class="contact-button">
        <el-icon><Service /></el-icon>
        <span>资讯信箱</span>
      </div>
      <div class="contact-divider"></div>
      <div class="contact-button">
        <el-icon><ChatDotRound /></el-icon>
        <span>英文切换</span>
      </div>
    </div>

    <!-- 头部 -->
    <header>
      <div class="header-top">
        <div class="logo">
          <div class="logo-img">
            <el-image src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/logo.png" />
          </div>
          <div class="logo-text">
            <el-text style="color: white; white-space: nowrap;" size="large">国普健康集团有限公司</el-text>
          </div>
        </div>
        <div class="location">
          <el-icon><Location /></el-icon>
          <span>北京</span>
        </div>
        <div class="header-title">
          <div class="choose">
            <el-image src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/change.png"></el-image>
          </div>
          <div class="choose-text">
            <el-text @click="switchLang" style="color: white" size="small">{{ $t('header.language') }}</el-text>
          </div>
        </div>
      </div>
      <div class="header-search-row">
        <div class="header-search">
          <el-input
              class="search-input"
              style="width: 280px"
              :placeholder="搜索您所需要的相关内容"
              :prefix-icon="Search"
          />
        </div>
      </div>
      <div class="header-tabs">
        <div class="tabs-body">
          <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane label="首页" name="first"></el-tab-pane>
            <el-tab-pane label="中创国安" name="second"></el-tab-pane>
            <el-tab-pane label="健康产品" name="third"></el-tab-pane>
            <el-tab-pane label="康养项目" name="fourth"></el-tab-pane>
            <el-tab-pane label="国普产业" name="fifth"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </header>

    <!-- 导航轮播 -->
    <nav>
      <div class="main-nav">
        <el-carousel height="130px" :interval="5000" indicator-position="outside">
          <el-carousel-item style="height: 167px" v-for="(slide, index) in slides" :key="index">
            <div class="carousel-content">
              <img :src="slide.imageUrl" alt="slide.title" class="carousel-image" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </nav>

    <!-- 主要内容区域 -->
    <article>
      <!-- 国普培训 -->
      <section class="project">
        <div class="camp-image1">
          <el-image
              src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/gppx.png"
              fit="contain"
          />
        </div>
      </section>

      <!-- 项目工程 -->
      <section class="project">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('sections.project') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="project-detail">
          <div class="project-left">
            <div class="top-img">
              <el-image
                  src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/program2.png"
              />
            </div>
            <div class="down-img">
              <el-image
                  src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/program1.png"
              />
            </div>
          </div>
          <div class="project-right">
            <el-text size="small">
              {{ $t('sections.projectText') }}
            </el-text>
          </div>
        </div>
      </section>

      <!-- 健康项目 -->
      <section class="health">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('tabs.healthProjects') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="health-detail">
          <div class="health-left">
            <el-image
                style="position: absolute;bottom: 0;"
                src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/project1.png"
            />
            <el-image
                style="position: absolute;right: 0"
                src="https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/project2.png"
            />
          </div>
          <div class="health-right">
            <el-text size="small">
              {{ $t('sections.programText') }}
            </el-text>
          </div>
        </div>
      </section>

      <!-- 健康产品 -->
      <section class="company">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('tabs.healthProducts') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="company-body">
          <el-carousel :interval="4000" type="card" height="150px">
            <el-carousel-item v-for="item in product" :key="item.imagePath">
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                <img :src="item.imagePath" alt="item.description" style="max-height: 100%; max-width: 100%; ">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>

      <!-- 子分公司 -->
      <section class="manage">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('sections.subsidiaries') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="manage-body">
          <div class="manage-center1">
            <div class="manage-title">
              <el-text tag="b">{{ $t('sections.manage1.title') }}</el-text>
            </div>
            <div class="manage-text">
              <el-text line-clamp="3" v-html="$t('sections.manage1.text')"></el-text>
            </div>
          </div>
          <div class="manage-center2">
            <div class="manage-title">
              <el-text tag="b">{{ $t('sections.manage2.title') }}</el-text>
            </div>
            <div class="manage-text">
              <el-text line-clamp="3" v-html="$t('sections.manage2.text')"></el-text>
            </div>
          </div>
          <div class="manage-center3">
            <div class="manage-title">
              <el-text tag="b">{{ $t('sections.manage3.title') }}</el-text>
            </div>
            <div class="manage-text">
              <el-text line-clamp="3" v-html="$t('sections.manage3.text')"></el-text>
            </div>
          </div>
        </div>
      </section>

      <!-- 热点部分 -->
      <section class="hotspot">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('sections.hotspot') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="hotspot-body">
          <div class="list-item">
            {{ $t('sections.hotspotNew1') }}
            <span><el-text type="info">2021-09-26</el-text></span>
          </div>
          <div class="list-item">
            {{ $t('sections.hotspotNew2') }}
            <span><el-text type="info">2021-09-26</el-text></span>
          </div>
          <div class="list-item">
            {{ $t('sections.hotspotNew3') }}
            <span><el-text type="info">2021-09-26</el-text></span>
          </div>
        </div>
      </section>

<!--      <section class="certificate">
        <div class="hotspot-head">
          <div class="hotspot-title">
            <el-text size="large" tag="b" style="letter-spacing: 2px;line-height: 18px;">{{ $t('sections.certificate') }}</el-text>
          </div>
          <div class="hotspot-more">
            <el-text type="info">{{ $t('sections.more') }}></el-text>
          </div>
        </div>
        <div class="certificate-body">
          <el-carousel :interval="4000" type="card" height="93px">
            <el-carousel-item v-for="item in qualifications" :key="item.imagePath">
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <img :src="item.imagePath" alt="item.description" style="max-height: 100%; max-width: 100%;">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>-->
    </article>

    <!-- 页脚 -->
    <footer>

      <div class="footer-button">
        <div class="footer-left">
          <el-image src="https://guopuwebsite.oss-cn-shenzhen.aliyuncs.com/zcga/unit.png"></el-image>
          <el-image src="https://guopuwebsite.oss-cn-shenzhen.aliyuncs.com/zcga/kxgw.png"></el-image>
          <!--          <el-image src="https://guopuwebsite.oss-cn-shenzhen.aliyuncs.com/zcga/cxdw.png"></el-image>-->
        </div>
      </div>

      <div class="footer-phone">
        <el-text style="color: #FFFFFF">{{ $t('sections.footerButtons.phone') }}</el-text>
      </div>
      <div class="footer-company">
        <el-text style="color: #FFFFFF">{{ $t('sections.footerButtons.company') }}</el-text>
      </div>
      <div class="footer-copy">
        <el-text style="color: #FFFFFF">{{ $t('sections.footerButtons.copyright') }}</el-text>
      </div>
      <div class="footer-phone">
        <el-text style="color: #FFFFFF">{{ $t('sections.footerButtons.record') }}</el-text>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { Search, Location, Service, ChatDotRound } from '@element-plus/icons-vue'
import {ref} from "vue";
import { useI18n} from "vue-i18n";

const { locale } = useI18n();
const activeName = ref('first')

function switchLang() {
  locale.value = locale.value === 'zh' ? 'en' : 'zh';
}

// 定义滑块数据，包括图片URL和标题
const slides = ref([
  {
    imageUrl: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/nav.png',
    title: '第一张图片标题'
  },
  {
    imageUrl: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/nav2.png',
    title: '第二张图片标题'
  },
  {
    imageUrl: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/nav3.png',
    title: '第三张图片标题'
  }
]);

const product = [
  {
    imagePath: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/newlogo/product1.png',
  },
  {
    imagePath: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/product2.png',
  },
  {
    imagePath: 'https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/gppx.png',
  },
]
</script>

<style scoped>
.content{
  width: 100%;
  min-height: 100vh;
  background-color: #f2f4f5;
  position: relative;
  overflow-x: hidden;
}
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #206CFB;
  padding: 5px 15px 0;
  height: 20px;
}

.time {
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.status-icons {
  display: flex;
  align-items: center;
}

.signal, .wifi, .battery {
  width: 15px;
  height: 15px;
  margin-left: 5px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.signal {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M2 22h20V2z'/%3E%3C/svg%3E");
}

.wifi {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 6c4.4 0 8 3.6 8 8h-2c0-3.3-2.7-6-6-6s-6 2.7-6 6H4c0-4.4 3.6-8 8-8zm0 4c2.2 0 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.2 1.8-4 4-4z'/%3E%3C/svg%3E");
}

.battery {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z'/%3E%3C/svg%3E");
}

.contact-buttons {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #206CFB;
  border-radius: 5px 0 0 5px;
  padding: 15px 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  font-size: 12px;
  cursor: pointer;
  padding: 10px 0;
}

.contact-button .el-icon {
  font-size: 24px;
  margin-bottom: 5px;
}

.contact-divider {
  width: 30px;
  height: 1px;
  background-color: white;
  margin: 5px 0;
}

header{
  background: #206CFB;
  height: 140px;
  position: relative;
}

.header-top {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  height: 45px;
}

.logo{
  display: flex;
  align-items: center;
  height: 30px;
  flex-direction: row-reverse;
  .logo-img{
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .logo-text{
    font-size: 16px;
  }
}
.header-title{
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  margin-left: auto;
}

.choose{
  width: 14px;
  height: 14px;
  float: left;
  margin-top: 6px;
}
.choose-text{
  float: left;
  width: 50px;
  margin-top: 4px;
  margin-left: 6px;
  color: white;
}
.location {
  display: flex;
  align-items: center;
  color: white;
  margin-left: 15px;
}
.location span {
  margin-left: 5px;
}
.header-search-row {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px 0;
}

.header-search{
  margin: 0 auto;
}

.search-input :deep(.el-input__wrapper) {
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.8);
}

.search-input :deep(.el-input__inner) {
  color: #333;
}

.header-tabs{
  width: 100%;
  height: 40px;
  background-color: white;
  position: absolute;
  bottom: 0px;
}

.tabs-body{
  width: 100%;
  max-width: 420px;
  height: 25px;
  margin: 0 auto;
}

nav{
  height: 130px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.main-nav{
  width: 100%;
  height: 130px;
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 160px;
}

.carousel-image {
  width: 100%;
  height: 167px;
  object-fit: cover;
}

article{
  width: 100%;
  max-width: 400px;
  margin: 20px auto 0;
  padding: 0 14px;
  box-sizing: border-box;
}

.company{
  width: 100%;
  height: auto;
  min-height: 210px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
  border-radius: 6px;
  margin-top: 30px;
  padding-bottom: 15px;
}

.hotspot-head{
  width:100%;
  height: 30px;
  padding: 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hotspot-title{
  margin-left: 26px;
  height: 18px;
}

.hotspot-more{
  margin-right: 26px;
}

.company-body{
  width: 90%;
  height: 150px;
  margin: 0 auto;
}

.manage{
  width: 100%;
  height: auto;
  min-height: 430px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
  border-radius: 6px;
  margin-top: 30px;
  padding-bottom: 15px;
}

.manage-body{
  width: 90%;
  height: auto;
  margin: 0 auto;
}

.manage-center1, .manage-center2, .manage-center3 {
  width: 100%;
  height: 115px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-bottom: 8px;
}

.manage-center1 {
  background-image: url("https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/company1.png");
}

.manage-center2 {
  background-image: url("https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/company2.png");
}

.manage-center3 {
  background-image: url("https://guopukangyang.oss-cn-shenzhen.aliyuncs.com/company3.png");
}

.manage-title{
  position: absolute;
  top: 18px;
  left: 20px;
  width: 80%;
}

.manage-text{
  position: absolute;
  width: 80%;
  top:55px;
  left: 20px;
}
.manage-text .el-text {
  font-size: 12px;
}
.hotspot{
  width: 100%;
  height: auto;
  min-height: 176px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
  border-radius: 6px;
  margin-top: 25px;
  padding-bottom: 15px;
}

.hotspot-body{
  height: auto;
  width: 90%;
  margin: 0 auto;
}

.list-item {
  border-bottom: 1px dashed blue;
  padding: 10px 0;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-item:last-child {
  border-bottom: none;
}

.list-item::before {
  content: "•";
  color: blue;
  display: inline-block;
  width: 0.5em;
  font-size: 16px;
  margin-right: 5px;
}

footer{
  width: 100%;
  height: auto;
  min-height: 220px;
  background-color: #206CFB;
  margin-top: 30px;
  padding: 24px 0;
  text-align: center;
}

.footer-button{
  width: 304px;
  height: 38px;
  margin: 0 auto;
}
.footer-left{
  width: 262px;
  height: 38px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px; /* 设置图片之间的间距 */
}
.footer-left .el-image {
  flex: 1;
  height: 100%;
}

.footer-left .el-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.footer-phone, .footer-company, .footer-copy {
  margin-top: 16px;
}

.footer-copy{
  width: 90%;
  margin: 10px auto 0;
}

.header-tabs .el-tabs__header,
.header-tabs .el-tabs__item {
  height: 30px;
  line-height: 30px;
}

.header-tabs .tabs-body {
  width: 100%;
  margin: 0 auto;
}

::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

.project{
  width: 100%;
  height: auto;
  min-height: 260px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
  border-radius: 6px;
  margin-top: 30px;
  padding-bottom: 15px;
}

.project-detail{
  width: 90%;
  height: auto;
  margin: 8px auto 0;
  display: flex;
  flex-wrap: wrap;
}

.project-left{
  width: 130px;
  height: 170px;
}

.top-img, .down-img {
  width: 130px;
  height: 81px;
  overflow: hidden;
}

.down-img{
  margin-top: 10px;
}

.project-left img, .down-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.project-right{
  width: calc(100% - 150px);
  height: 170px;
  margin-left: 20px;
}

.health{
  width: 100%;
  height: auto;
  min-height: 180px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
  border-radius: 6px;
  margin-top: 30px;
  padding-bottom: 15px;
}

.health-detail{
  width: 90%;
  height: auto;
  margin: 8px auto 0;
  display: flex;
  flex-wrap: wrap;
}

.health-left{
  width: 135px;
  height: 105px;
  position: relative;
}

.health-right{
  width: calc(100% - 155px);
  height: 105px;
  margin-left: 20px;
}

.health-left img {
  width: 50%;
  height: 50%;
  object-fit: cover;
}

.camp-image1 {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.camp-image1 img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* 响应式设计 */
/*@media (max-width: 480px) {
  .project-detail, .health-detail {
    flex-direction: column;
  }

  .project-left, .project-right, .health-left, .health-right {
    width: 100%;
    margin-left: 0;
    margin-bottom: 15px;
  }

  .header-search {
    width: 90%;
  }

  .search-input {
    width: 100% !important;
  }

  .tabs-body {
    width: 100%;
  }
}*/
</style>